var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full lg:flex-1 lg:mb-0 cursor-pointer relative" },
    [
      _c(
        "multiselect",
        {
          attrs: {
            closeOnSelect: false,
            searchable: false,
            "close-on-select": false,
            "clear-on-select": false,
            "preserve-search": true,
            label: "attribute_name",
            "track-by": "term_taxonomy_id",
            multiple: true,
            placeholder: _vm.placeholder,
            selectLabel: "",
            selectGroupLabel: "",
            selectedLabel: "",
            deselectLabel: "",
            deselectGroupLabel: "",
            "open-direction": "bottom",
            showLabels: false,
            options: _vm.options,
          },
          on: { input: _vm.selectChanged },
          scopedSlots: _vm._u([
            {
              key: "selection",
              fn: function (ref) {
                var values = ref.values
                var search = ref.search
                var isOpen = ref.isOpen
                return [
                  values.length && !isOpen
                    ? _c("span", { staticClass: "multiselect__single" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.placeholder) +
                            ": " +
                            _vm._s(values.length) +
                            "\n      "
                        ),
                      ])
                    : _vm._e(),
                ]
              },
            },
            {
              key: "option",
              fn: function (props) {
                return [
                  _c("div", { staticClass: "option-row" }, [
                    _c("div", { staticClass: "checkbox-wrap" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "10",
                            height: "10",
                            viewBox: "0 0 78.369 78.369",
                          },
                        },
                        [
                          _c("path", {
                            staticClass: "active-path",
                            attrs: {
                              d: "M66.25 25.138l-33.84 33.84a.762.762 0 01-1.077 0L12.119 39.763a.762.762 0 010-1.077l4.669-4.67a.763.763 0 011.078 0l14.007 14.007 28.631-28.632a.763.763 0 011.078 0l4.668 4.67a.762.762 0 010 1.077z",
                              "data-original": "#000000",
                              "data-old_color": "#000000",
                              fill: "#0072ce",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "option__title" }, [
                      _vm._v(_vm._s(props.option.attribute_name)),
                    ]),
                  ]),
                ]
              },
            },
          ]),
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _c("template", { slot: "caret" }, [
            _c("span", { staticClass: "caret" }, [
              _c(
                "svg",
                {
                  attrs: {
                    id: "SVGDoc",
                    width: "16",
                    height: "10",
                    xmlns: "http://www.w3.org/2000/svg",
                    version: "1.1",
                    viewBox: "0 0 16 10",
                  },
                },
                [
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        attrs: {
                          d: "M15.99981,1.44806v0l-0.8,-0.7322v0l-7.2,7.00168v0l-7.2,-7.00168v0l-0.8,0.7322v0l7.90588,7.73388v0l0.09412,-0.09153v0l0.09412,0.09153v0z",
                          fill: "#5d6162",
                          "fill-opacity": "1",
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/vue-loader/lib?{}!./scripts/components/MSelect.vue?vue&type=template&id=665e73ca&
// module id = 628
// module chunks = 0